import {gql} from "@apollo/client";

export const ADD_ALERT = gql`
    mutation AddAlert($alertsInput: AlertsInput) {
        addAlert(AlertsInput: $alertsInput) {
            routeNode
            type
            status
            spaceConnection
            date
        }
    }`

export const ALERTS_QUERY = gql`
    query AlertsQuery {
        Alerts {
            routeNode
            type
            status
            spaceConnection
            date
            levels
            location
            station
        }
    }
`;